enum PubSubEventEnum
{
	ADMIN_USER_SUBSCRIPTION_UPDATE = "admin-user-subscription-update",
	ADMIN_CONTACT_MESSAGE_UPDATE = "admin-contact-message-update",
	ADMIN_SURVEY_UPDATE = "admin-survey-update",
	ADMIN_LOST_ITEM_UPDATE = "admin-lost-item-update",
	ADMIN_ACTIVITY_LOG_CREATE = "admin-activity-log-create",
	ADMIN_SESSION_UPDATE = "admin-session-update",
	ADMIN_EVENT_REGISTRATION_UPDATE = "admin-event-registration-update",
	ADMIN_USER_REGISTER = "admin-user-register",
	ADMIN_MEDIA_UPLOADED_FROM_MOBILE = "admin-media-uploaded-from-mobile",
	ADMIN_API_CALL = "admin-api-call",
	ADMIN_SALE_CREATE = "admin-sale-create",

	NEWS_UPDATE = "news-update",
	BROADCAST_PUBLISHED = "broadcast-published",
	BROADCAST_UPDATED = "broadcast-updated",
	BROADCAST_DELETED = "broadcast-deleted",
	BROADCAST_REACTION_UPDATED = "broadcast-reaction-updated",
	SURVEY_UPDATE = "survey-update",
	LOST_ITEM_UPDATE = "lost-item-update",
	USER_SESSIONS_UPDATED = "user-sessions-updated",
	USER_SCORES_UPDATED = "user-scores-updated",
	USER_PURCHASES_UPDATED = "user-purchases-updated",
	USER_EVENTS_UPDATED = "user-events-updated",
	PUBLIC_SESSION_UPDATE = "public-session-update",
	SESSION_DATA_UPDATE = "session-data-update",
	EVENT_PARTICIPANTS_UPDATED = "event-participants-updated",
	PRODUCT_UPDATE = "product-update",

	COACH_TIMER = "coach-timer",
}

export default PubSubEventEnum;
